import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";

// import the auto exporter
import modules from "./modules";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules,
  actions: {
    reset({ commit }) {
      for(const moduleName in modules) {
        const mutation = `${moduleName}/reset`
        commit(mutation);
        console.log('Mutaion: ', mutation)
      }
    }
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [] // set logger only for development
});
